import { useRef } from 'react';
import { getAlbumSource, isClient } from '../utils';
export var useAudio = function useAudio() {
  var audio = useRef(isClient ? new Audio() : {});
  var play = function play() {
    audio.current.play();
  };
  var pause = function pause() {
    audio.current.pause();
  };
  var src = function src(inputSource) {
    audio.current.src = inputSource;
  };
  var reset = function reset() {
    audio.current.pause();
    audio.current.currentTime = 0;
  };
  var mute = function mute() {
    audio.current.muted = true;
  };
  var unmute = function unmute() {
    audio.current.muted = false;
  };
  var setVolume = function setVolume(volume) {
    audio.current.volume = volume;
  };
  var setCurrentTime = function setCurrentTime(time) {
    audio.current.currentTime = time;
  };
  var skipBackwards = function skipBackwards() {
    audio.current.currentTime -= 5.0;
  };
  var skipForwards = function skipForwards() {
    audio.current.currentTime += 5.0;
  };
  var playNewTrack = function playNewTrack(track) {
    var trackSource = getAlbumSource(track);
    audio.current.src = trackSource;
    audio.current.play();
  };
  return {
    play: play,
    pause: pause,
    src: src,
    reset: reset,
    mute: mute,
    unmute: unmute,
    setVolume: setVolume,
    setCurrentTime: setCurrentTime,
    skipBackwards: skipBackwards,
    skipForwards: skipForwards,
    playNewTrack: playNewTrack,
    audioElement: audio.current
  };
};